import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PackageConfigurationServices {
  constructor(private http:HttpClient) { }

  packageConfig(data:any){
    return this.http.post(environment.apiUrl + "packageConfig/addNew" , data)
  }

}